const Strings = {
  TO_SIGN_IN: {
    SE: 'Till logga in',
    EN: 'To sign in'
  },
  APARTMENT_CODE: {
    SE: 'Lägenhetskod*',
    EN: 'Apartment code*'
  },
  APARTMENT_NUMBER: {
    SE: 'Lägenhetsnummer*',
    EN: 'Apartment number*'
  },
  EMAIL_ADDRESS: {
    SE: 'Mailadress*',
    EN: 'Email address*'
  },
  PHONE_NUMBER: {
    SE: 'Telefonnummer*',
    EN: 'Phone number*'
  },
  REPEAT_EMAIL_ADDRESS: {
    SE: 'Upprepa mailadress*',
    EN: 'Repeat email address*'
  },
  PASSWORD: {
    SE: 'Lösenord*',
    EN: 'Password*'
  },
  REPEAT_PASSWORD: {
    SE: 'Upprepa lösenord*',
    EN: 'Repeat password*'
  },
  CREATE_ACCOUNT: {
    SE: 'Skapa konto',
    EN: 'Create account'
  },
  FORGOT_PASSWORD: {
    SE: 'Glömt lösenord?',
    EN: 'Forgot your password?'
  },
  MANDATORY_FIELDS: {
    SE: 'Fyll i alla obligatoriska fält',
    EN: 'Enter all mandatory fields'
  },
  MANDATORY_FIELDS_INFO: {
    SE: 'Var god fyll i alla obligatoriska fält och försök igen.',
    EN: 'Please enter all the mandatory fields and try again.'
  },
  OK: {
    SE: 'Okej',
    EN: 'Okey'
  },
  EMAILS_DONT_MATCH: {
    SE: 'Emailadresserna matchar ej',
    EN: 'The email addresses does not match'
  },
  EMAILS_DONT_MATCH_INFO: {
    SE: 'Emailadresserna matchar ej, var god försök igen.',
    EN: 'The email addresses does not match, please try again.'
  },
  PASSWORDS_DONT_MATCH: {
    SE: 'Lösenorden matchar ej',
    EN: 'The passwords does not match'
  },
  PASSWORDS_DONT_MATCH_INFO: {
    SE: 'Lösenorden matchar ej, var god försök igen.',
    EN: 'The passwords does not match, please try again.'
  },
  NOT_VALID_EMAIL: {
    SE: 'Emailadressen är ej giltlig',
    EN: 'The email address is not valid'
  },
  NOT_VALID_EMAIL_INFO: {
    SE: 'Emailadressen är ej giltlig, var god försök igen.',
    EN: 'The email address is not valid, please try again.'
  },
  HOUSING_ASSOCIATION_CODE: {
    SE: 'Föreningskod*',
    EN: 'Housing association code*'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/SignUp/strings.js